import { useMutation } from '@tanstack/react-query';

import { createCaseInEhrFn } from './api';

import type { UseMutateFunction } from '@tanstack/react-query';
import type { CreateCaseInEhrDataProps } from './api';

interface Props {
  onSuccess: () => void;
}

export type TCreateCaseInEhr = UseMutateFunction<
  { response: string } | undefined,
  unknown,
  CreateCaseInEhrDataProps,
  unknown
>;

export const useCreateCaseInEhr = ({ onSuccess }: Props) => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: createCaseInEhrFn,
    onSuccess,
  });

  return { createCaseInEhr: mutateAsync, createCaseInEhrLoading: isLoading };
};
